import { createContext } from 'react';

import type { IEventsProviderContext } from '../types';

export const EventsProvierContext = createContext({} as IEventsProviderContext);
